import { categories } from "@dust/world/internal";
import { useEffect } from "react";
import { useAppStore } from "../../../store/appStore";
import { objectsByObjectType } from "../Blueprint";
import { useSelectedObjectTypeQuery } from "../useSelectedObjectTypeQuery";

export function useAutoSwitch() {
  const { autoSwitch, setActiveObjectTypeId } = useAppStore();
  const { data: selectedObjectType } = useSelectedObjectTypeQuery(autoSwitch);

  useEffect(() => {
    if (autoSwitch) {
      if (selectedObjectType) {
        const selectedObject = objectsByObjectType[selectedObjectType];
        if (
          selectedObject &&
          categories.Tool.objects.includes(selectedObject.name)
        ) {
          setActiveObjectTypeId(1);
        } else {
          setActiveObjectTypeId(selectedObjectType);
        }
      } else {
        setActiveObjectTypeId(0);
      }
    }
  }, [autoSwitch, selectedObjectType, setActiveObjectTypeId]);
}
